export default "__VITE_ASSET__xTH1Zc3z__"